import { Button, CircularProgress, Grid, Typography } from '@mui/material';
import React, { Fragment, useEffect, useReducer } from 'react';
import { initialState, default as reducer } from './AuthenticatorCode.reducer';

import Actions from './AuthenticatorCode.actions';
import { setupTOTP as GetQRCodeService } from '../../../authentication/services';
import Locale from '../Locale';
import { MFA_ISSUER } from '#config/runtimeconfig';
import PropTypes from 'prop-types';
import { QRCodeSVG } from 'qrcode.react';
import styled from '@emotion/styled';

const QRGridItem = styled(Grid)(({ theme }) => ({
    margin: theme.spacing(1),
    textAlign: 'center',
}));

const AuthenticatorCode = props => {
    const { onCopy, userId, issuer = MFA_ISSUER || 'Osano' } = props;
    const [state, dispatch] = useReducer(reducer, initialState);
    const { isLoading, qrCode, qrUri, error } = state;
    useEffect(() => {
        dispatch(Actions.generateCodeBegin());
        GetQRCodeService()
            .then(setupTotpDetails =>
                dispatch(
                    Actions.generateCodeSuccess({
                        issuer,
                        userId,
                        qrCode: setupTotpDetails.sharedSecret,
                    })
                )
            )
            .catch(error => dispatch(Actions.generateCodeFailure(error)));
    }, [userId]);

    return (
        <Grid
            container
            spacing={0}
            direction="column"
            alignItems="stretch"
            justifyContent="stretch"
        >
            {isLoading || error ? (
                error ? (
                    <QRGridItem item xs>
                        <Typography color="error" variant="body1" component="p">
                            <Locale path={error?.message ?? error} />
                        </Typography>
                    </QRGridItem>
                ) : (
                    <Fragment>
                        <QRGridItem item xs>
                            <Typography variant="body1" component="p">
                                <Locale path="auth.amplify.mfa.setup.totp.generating" />
                            </Typography>
                        </QRGridItem>
                        <QRGridItem item xs={6}>
                            <CircularProgress />
                        </QRGridItem>
                    </Fragment>
                )
            ) : (
                <Fragment>
                    <input type="hidden" name="qrCode" value={qrCode} readOnly />
                    <input type="hidden" name="issuer" value={issuer} readOnly />
                    <input type="hidden" name="userId" value={userId} readOnly />
                    <QRGridItem item xs>
                        <Typography variant="body1" component="p">
                            <Locale path="auth.amplify.mfa.setup.totp.qr" />
                        </Typography>
                    </QRGridItem>
                    <QRGridItem item xs={6}>
                        <QRCodeSVG size={256} bgColor="transparent" value={qrUri} />
                    </QRGridItem>
                    <QRGridItem item xs>
                        <Typography variant="body1" component="p">
                            <Locale path="auth.amplify.mfa.setup.totp.secretKey" />
                        </Typography>
                    </QRGridItem>
                    <Grid item xs sx={{ my: 2, mx: 0, textAlign: 'center' }}>
                        <Button
                            fullWidth
                            sx={{ p: 2, wordBreak: 'break-word' }}
                            color="secondary"
                            variant="contained"
                            onClick={() => onCopy(qrCode)}
                        >
                            {qrCode}
                        </Button>
                    </Grid>
                </Fragment>
            )}
        </Grid>
    );
};

AuthenticatorCode.propTypes = {
    userId: PropTypes.string.isRequired,
    issuer: PropTypes.string,
    onCopy: PropTypes.func.isRequired,
};

export default AuthenticatorCode;
